import { defineComponent, computed } from "vue";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "badge",
  props: {
    defaultFontSize: { default: void 0 },
    mobileFontSize: { default: void 0 },
    disableMinContent: { type: Boolean },
    positionDefault: { default: void 0 },
    positionMobile: { default: void 0 },
    magenta: { type: Boolean },
    black: { type: Boolean },
    white: { type: Boolean },
    bold: { type: Boolean },
    text: { default: void 0 }
  },
  setup(__props, { expose }) {
    const props = __props;
    const getPositions = (params, breakpoint) => {
      const variables = [];
      ["top", "right", "bottom", "left"].forEach((property) => {
        const cssValue = params[property];
        if (!cssValue && cssValue !== 0) {
          return;
        }
        if (Number.isNaN(Number(cssValue))) {
          variables.push(`--badge-${breakpoint}-${property}: ${cssValue};`);
          return;
        }
        variables.push(`--badge-${breakpoint}-${property}: ${cssValue}px;`);
      });
      return variables.join(" ");
    };
    const getFontSize = (size, breakpoint) => {
      if (isNaN(size)) {
        return `--badge-${breakpoint}-size: ${size};`;
      }
      return `--badge-${breakpoint}-size: ${size}px;`;
    };
    const styles = computed(() => {
      const variables = [];
      if (props.positionMobile) {
        variables.push(getPositions(props.positionMobile, "xs"));
      }
      if (props.positionDefault) {
        variables.push(getPositions(props.positionDefault, "sm"));
      }
      if (props.mobileFontSize) {
        variables.push(getFontSize(props.mobileFontSize, "xs"));
      }
      if (props.defaultFontSize) {
        variables.push(getFontSize(props.defaultFontSize, "sm"));
      }
      return variables.join(" ").trim();
    });
    const containerClasses = computed(() => {
      const classNames = [];
      if (props.bold)
        classNames.push("badge--bold");
      if (props.magenta)
        classNames.push("badge--magenta");
      else if (props.black)
        classNames.push("badge--black");
      else if (props.white)
        classNames.push("badge--white");
      if (!props.disableMinContent)
        classNames.push("badge--min-content");
      return classNames.join(" ");
    });
    expose({ getPositions, containerClasses, styles });
    return { __sfc: true, props, getPositions, getFontSize, styles, containerClasses };
  }
});
export {
  _sfc_main as default
};
